import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import pick from 'lodash/pick';
import Help from './Help';
import { getSuffix } from '../../../lib/apiKeys';
import a from '../../../redux/actions';
import s from '../../../redux/selectors';
import types from '../../../types';
import { wrap, withT } from '../../../lib/wrappers';

const NumericInputWithUnits = ({
  t,
  unitOptions,
  inputValue,
  unitsDisplay,
  apiKey,
  unitApiKey,
  title,
  updateNumericInput,
  setMonthlyInput,
  isMonthlyInput,
}) => {
  const inputSuffix = getSuffix(apiKey);
  const unitSuffix = getSuffix(unitApiKey);

  return (
    <div className="cc-component__question">
      <h4>
        {title(t)}
        <Help t={t} helpKey={apiKey} />
      </h4>
      <div className="input-group">
        <input
          aria-label={title(t)}
          className="form-control cc-component__question-input"
          onChange={e => updateNumericInput({ [inputSuffix]: e.target.value })}
          value={inputValue.inputDisplay}
          placeholder={inputValue.defaultDisplay}
        />
        <div className="input-group-btn">
          <button
            type="button"
            className="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            // allow units display to include super and subscripts.
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: `${unitsDisplay}&nbsp;<span class="caret"></span>` }}
          />
          <ul className="dropdown-menu">
            {unitOptions.map(unit => (
              <li key={unit.value}>
                <a
                  href="#"
                  onClick={e =>
                    e.preventDefault() || updateNumericInput({ [unitSuffix]: unit.value })
                  }
                  // allow units display to include super and subscripts.
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: unit.display }}
                />
              </li>
            ))}
          </ul>
        </div>
        <div className="input-group-btn">
          <button
            type="button"
            className="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
          >
            /&nbsp;{isMonthlyInput ? t('mo', { ns: 'units' }) : t('yr', { ns: 'units' })}&nbsp;
            <span className="caret" />
          </button>
          <ul className="dropdown-menu">
            <li>
              <a
                href="#"
                onClick={
                  e => e.preventDefault() || setMonthlyInput(apiKey, false)
                }
              >
                {t('yr', { ns: 'units' })}
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={e =>
                  e.preventDefault() || setMonthlyInput(apiKey, true)
                }
              >
                {t('mo', { ns: 'units' })}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

NumericInputWithUnits.propTypes = {
  // ownProps
  apiKey: PropTypes.string.isRequired,
  unitApiKey: PropTypes.string.isRequired,
  title: PropTypes.func.isRequired,
  // wrapped props
  t: PropTypes.func.isRequired,
  // connected props
  inputValue: types.UserInput.isRequired,
  unitsDisplay: PropTypes.string.isRequired,
  setMonthlyInput: PropTypes.func.isRequired,
  updateNumericInput: PropTypes.func.isRequired,
  isMonthlyInput: PropTypes.bool.isRequired,
  unitOptions: types.UnitsOptions.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'isMetric',
  'isMonthlyInput',
  'unitsDisplay',
  'inputValue',
  'unitOptions',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});


const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'updateNumericInput',
    'setMonthlyInput',
  ]),
  dispatch,
);

export default wrap(
  withT('home'),
  connect(mapStateToProps, mapDispatchToProps),
  NumericInputWithUnits,
);

